import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** PATCH `/fms/vouchers/{id}/remark`。body：`remark`、`updatedAt`。 */
export async function updateVoucherRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/fms/vouchers/${id}/remark`,
    keysToSnake(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
